import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Typography, Box, Card, Button, IconButton, Chip } from "@material-ui/core";
import { ArrowBack, School, Payment, CheckCircle, GetApp, AccountBalance, PhoneAndroid, CreditCard } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import SchoolService from "./Locality/Service/schoolService";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
  },
  header: {
    backgroundColor: "#FFD700",
    color: "#000",
    boxShadow: "none",
  },
  headerContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    position: "relative",
  },
  backButton: {
    color: "#000",
    position: "absolute",
    left: "0",
  },
  title: {
    fontWeight: "bold",
    fontSize: "1.2rem",
  },
  babyIcon: {
    fontSize: "2rem",
  },
  studentInfo: {
    backgroundColor: "#f8f9fa",
    padding: "16px",
    borderRadius: "8px",
    marginBottom: "16px",
  },
  content: {
    padding: "16px",
    backgroundColor: "#fff",
    margin: "16px",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
  receiptHeader: {
    textAlign: "center",
    marginBottom: "20px",
  },
  receiptNumber: {
    fontSize: "1.3rem",
    fontWeight: "bold",
    color: "#1976d2",
    marginBottom: "12px",
    textAlign: "center",
    padding: "8px 16px",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
  },
  statusChip: {
    backgroundColor: "#4CAF50",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "0.9rem",
    padding: "6px 12px",
  },
  sectionTitle: {
    fontSize: "1.1rem",
    fontWeight: "bold",
    color: "#1976d2",
    marginBottom: "12px",
    marginTop: "20px",
  },
  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 0",
    borderBottom: "1px solid #f0f0f0",
  },
  infoLabel: {
    fontSize: "0.9rem",
    color: "#666",
    fontWeight: "500",
  },
  infoValue: {
    fontSize: "0.9rem",
    color: "#333",
    fontWeight: "600",
  },
  amountValue: {
    fontSize: "1.1rem",
    fontWeight: "bold",
    color: "#2e7d32",
  },
  paymentMethod: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  paymentIcon: {
    fontSize: "1.2rem",
    color: "#666",
  },
  downloadButton: {
    backgroundColor: "#1976d2",
    color: "#fff",
    minWidth: "48px",
    height: "48px",
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: "#1565c0",
    },
  },
  schoolInfoCard: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    borderRadius: "16px",
    marginBottom: "24px",
    boxShadow: "0 8px 32px rgba(102, 126, 234, 0.3)",
    border: "none",
    overflow: "hidden",
  },
  schoolInfoContent: {
    display: "flex",
    alignItems: "center",
    padding: "20px",
    color: "#fff",
  },
  schoolIconContainer: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    borderRadius: "50%",
    padding: "12px",
    marginRight: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  schoolIcon: {
    fontSize: "2rem",
    color: "#fff",
  },
  schoolDetails: {
    flex: 1,
  },
  schoolName: {
    fontSize: "1.4rem",
    fontWeight: "bold",
    color: "#fff",
    marginBottom: "4px",
    textShadow: "0 2px 4px rgba(0,0,0,0.3)",
  },
  schoolSubtitle: {
    fontSize: "0.9rem",
    color: "rgba(255, 255, 255, 0.8)",
    fontWeight: "500",
  },
  updatedInfo: {
    backgroundColor: "#e3f2fd",
    padding: "16px",
    borderRadius: "12px",
    marginBottom: "20px",
    textAlign: "center",
    fontSize: "1rem",
    color: "#1976d2",
    fontWeight: "600",
    border: "2px solid #bbdefb",
    boxShadow: "0 2px 4px rgba(25, 118, 210, 0.1)",
  },
  receiptCard: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "20px",
    marginBottom: "16px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
  footer: {
    backgroundColor: "#FFD700",
    padding: "16px",
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
  },
  footerButton: {
    backgroundColor: "#000",
    color: "#FFD700",
    fontWeight: "bold",
    padding: "12px 24px",
    borderRadius: "8px",
    textTransform: "none",
    fontSize: "1rem",
    width: "100%",
    "&:hover": {
      backgroundColor: "#333",
    },
  },
}));

export default function PaymentReceiptPage({ 
  student, 
  installment, 
  paymentDetails,
  onBack 
}) {
  const classes = useStyles();
  const [currentSchool, setCurrentSchool] = useState(null);

  const [currentTime] = useState(new Date().toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }));

  useEffect(() => {
    getSchooleRegistrationById();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "Not specified";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  
  const getSchooleRegistrationById = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    console.log("User details from localStorage:", userDetails);
    
    // Try multiple possible school ID fields
    const schooleId = userDetails?.schooleId || userDetails?.schoolId || userDetails?.schooleID || student?.schooleId?._id;
    
    if (!schooleId) {
      console.warn("No school id found in userDetail or student.");
      // Fallback to student school info if available
      if (student?.schooleId) {
        setCurrentSchool({
          _id: student.schooleId._id,
          schooleName: student.schooleId.schoolName || student.schooleId.schooleName
        });
      }
      return;
    }
    
    console.log("Fetching school with ID:", schooleId);
    SchoolService.getSchooleRegistrationById(schooleId)
      .then((res) => {
        console.log("School API response:", res);
        // API returns a single school object
        const school = res?.data || res;
        console.log("Setting current school:", school);
        setCurrentSchool(school);
      })
      .catch((err) => {
        console.error("Error fetching school by id:", err);
        // Fallback to student school info on error
        if (student?.schooleId) {
          setCurrentSchool({
            _id: student.schooleId._id,
            schooleName: student.schooleId.schoolName || student.schooleId.schooleName
          });
        }
      });
  }
  const formatDateTime = (dateString) => {
    if (!dateString) return "Not specified";
    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getPaymentMethodIcon = (method) => {
    switch (method?.toLowerCase()) {
      case 'upi':
        return <PhoneAndroid className={classes.paymentIcon} />;
      case 'card':
        return <CreditCard className={classes.paymentIcon} />;
      case 'netbanking':
        return <AccountBalance className={classes.paymentIcon} />;
      default:
        return <Payment className={classes.paymentIcon} />;
    }
  };

  const handleDownload = () => {
    // Implement download functionality
    console.log("Downloading receipt...");
  };

  return (
    <div className={classes.root}>
      {/* Header */}
      <AppBar position="static" className={classes.header}>
        <Toolbar>
          <div className={classes.headerContent}>
            <IconButton
              edge="start"
              className={classes.backButton}
              onClick={onBack}
            >
              <ArrowBack />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {installment?.label || "Payment"} Receipt
            </Typography>
            {/* <Typography variant="body2">
              {currentTime}
            </Typography> */}
          </div>
        </Toolbar>
      </AppBar>

      {/* Content */}
        <div className={classes.content}>
          {/* School Info */}
          <Card className={classes.schoolInfoCard}>
            <div className={classes.schoolInfoContent}>
              <div className={classes.schoolIconContainer}>
                <School className={classes.schoolIcon} />
              </div>
              <div className={classes.schoolDetails}>
                <Typography className={classes.schoolName}>
                  {currentSchool?.schooleName || student?.schooleId?.schoolName || "Montessori School"}
                </Typography>
                <Typography className={classes.schoolSubtitle}>
                  Educational Institution
                </Typography>
              </div>
            </div>
          </Card>

        {/* Receipt Header */}
        <div className={classes.receiptHeader}>
          {/* <Typography className={classes.receiptNumber}>
            {currentSchool?.schooleName || student?.schooleId?.schoolName || "Montessori School"}
          </Typography> */}
          <Chip
            label="Paid"
            className={classes.statusChip}
            icon={<CheckCircle />}
          />
        </div>

        {/* Invoice Details */}
        <Card className={classes.receiptCard}>
          <Typography className={classes.sectionTitle}>Invoice Details</Typography>
          
          <div className={classes.infoRow}>
            <Typography className={classes.infoLabel}>Child Name</Typography>
            <Typography className={classes.infoValue}>
              {student?.fullName || "N/A"}
            </Typography>
          </div>
          
          <div className={classes.infoRow}>
            <Typography className={classes.infoLabel}>Program</Typography>
            <Typography className={classes.infoValue}>
              {student?.classId?.className || "N/A"} {student?.academicYear ? `(${student.academicYear})` : ""}
            </Typography>
          </div>
          
          <div className={classes.infoRow}>
            <Typography className={classes.infoLabel}>Bill ID</Typography>
            <Typography className={classes.infoValue}>
              {paymentDetails?.billId || "CrayBach001299"}
            </Typography>
          </div>
          
          <div className={classes.infoRow}>
            <Typography className={classes.infoLabel}>Status</Typography>
            <Chip
              label="Paid"
              className={classes.statusChip}
              size="small"
            />
          </div>
        </Card>

        {/* Fee Details */}
        <Card className={classes.receiptCard}>
          <Typography className={classes.sectionTitle}>Fee Details (INR)</Typography>
          
          <div className={classes.infoRow}>
            <Typography className={classes.infoLabel}>
              {installment?.label || "Installment"}
            </Typography>
            <Typography className={classes.amountValue}>
              ₹{installment?.amount || 0}
            </Typography>
          </div>
          
          <div className={classes.infoRow}>
            <Typography className={classes.infoLabel}>Due Date</Typography>
            <Typography className={classes.infoValue}>
              {formatDate(installment?.date)}
            </Typography>
          </div>
        </Card>

        {/* Payment Details */}
        <Card className={classes.receiptCard}>
          <Typography className={classes.sectionTitle}>Payment Details</Typography>
          
          <div className={classes.infoRow}>
            <Typography className={classes.infoLabel}>Amount Paid</Typography>
            <Typography className={classes.amountValue}>
              ₹{paymentDetails?.amountPaid || installment?.amount || 0}
            </Typography>
          </div>
          
          <div className={classes.infoRow}>
            <Typography className={classes.infoLabel}>Amount Due</Typography>
            <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Typography className={classes.amountValue}>
                ₹{paymentDetails?.amountDue || 0}
              </Typography>
              <IconButton
                className={classes.downloadButton}
                onClick={handleDownload}
                size="small"
              >
                <GetApp />
              </IconButton>
            </Box>
          </div>
          
          <div className={classes.infoRow}>
            <Typography className={classes.infoLabel}>Mode of Payment</Typography>
            <div className={classes.paymentMethod}>
              {getPaymentMethodIcon(paymentDetails?.paymentMode)}
              <Typography className={classes.infoValue}>
                {paymentDetails?.paymentMode || "EaseBuzz-UPI"}
              </Typography>
            </div>
          </div>
          
          <div className={classes.infoRow}>
            <Typography className={classes.infoLabel}>Reference Number</Typography>
            <Typography className={classes.infoValue}>
              {paymentDetails?.referenceNumber || "E2506060H8E7CV"}
            </Typography>
          </div>
          
          <div className={classes.infoRow}>
            <Typography className={classes.infoLabel}>Paid by</Typography>
            <Typography className={classes.infoValue}>
              {paymentDetails?.paidBy || "Rekha (Mother)"}
            </Typography>
          </div>
          
          <div className={classes.infoRow}>
            <Typography className={classes.infoLabel}>Date of Payment</Typography>
            <Typography className={classes.infoValue}>
              {formatDateTime(paymentDetails?.paymentDate || new Date())}
            </Typography>
          </div>
          
          <div className={classes.infoRow}>
            <Typography className={classes.infoLabel}>Receipt Number</Typography>
            <Typography className={classes.infoValue}>
              {paymentDetails?.receiptNumber || "CrayBach001299"}
            </Typography>
          </div>
        </Card>
      </div>

      {/* Footer */}
      <div >
        <Button
          className={classes.footerButton}
          onClick={handleDownload}
        >
          Download Receipt
        </Button>
      </div>
    </div>
  );
}
